var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 0.499634C1.84315 0.499634 0.5 1.84278 0.5 3.49963V12.4996C0.5 14.1565 1.84315 15.4996 3.5 15.4996H12.5C14.1569 15.4996 15.5 14.1565 15.5 12.4996V3.49963C15.5 1.84278 14.1569 0.499634 12.5 0.499634H3.5ZM12.9088 5.38605C13.1222 5.16029 13.1122 4.80428 12.8864 4.59087C12.6607 4.37746 12.3046 4.38747 12.0912 4.61322L6.82813 10.1808L4.65877 7.88595C4.44536 7.66019 4.08934 7.65018 3.86359 7.8636C3.63783 8.07701 3.62782 8.43302 3.84123 8.65878L6.41936 11.386C6.52561 11.4984 6.67346 11.5621 6.82813 11.5621C6.9828 11.5621 7.13064 11.4984 7.23689 11.386L12.9088 5.38605Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedBox);
export default __webpack_public_path__ + "static/media/IconCheckedBox.eb0a125e8b303b1a0fca991f4a50fb63.svg";
export { ForwardRef as ReactComponent };